import type { ProviderProgressEntry } from "../../../hooks/useProviderProgress";

export type RunLifecycleStatus = "idle" | "active" | "ended" | "error";

export function getRunLifecycleStatus(
  events: ProviderProgressEntry[],
): RunLifecycleStatus {
  for (let index = events.length - 1; index >= 0; index -= 1) {
    const eventType = events[index]?.event_type;

    switch (eventType) {
      case "run:end": {
        return "ended";
      }
      case "run:error": {
        return "error";
      }
      case "run:start": {
        return "active";
      }
      default: {
        break;
      }
    }
  }

  return "idle";
}
